"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "۰۱",
  title: "رزرو نوبت",
  description: "اولین قدم برای شروع مسیر بهبودی، انتخاب زمان مناسب برای یک گفتگوی صمیمانه و تخصصی است.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/booking_session.png"
}, {
  number: "۰۲",
  title: "مشاوره اولیه",
  description: "در این جلسه، با بررسی دقیق دغدغه‌ها و تاریخچه فردی، ریشه‌های چالش‌های شما را شناسایی می‌کنیم.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/initial_consultation.png"
}, {
  number: "۰۳",
  title: "برنامه درمانی اختصاصی",
  description: "بر اساس نیازهای منحصر به فرد شما، یک نقشه راه علمی و گام‌به‌گام برای رسیدن به آرامش طراحی می‌شود.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/personalized_plan.png"
}, {
  number: "۰۴",
  title: "پشتیبانی مستمر",
  description: "در تمام طول مسیر تغییر و رشد، من در کنار شما هستم تا پایداری دستاوردهای درمانی را تضمین کنیم.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/ongoing_support.png"
}];
function StepCard({
  step,
  align
}: {
  step: typeof steps[0];
  align: 'left' | 'right';
}) {
  return <div className={`flex flex-col gap-6 w-full max-w-[400px] ${align === 'right' ? 'md:items-end md:text-right' : 'md:items-start md:text-left'} items-start text-left`}>
      <div className="relative overflow-hidden rounded-lg border border-border/60 shadow-md group-hover:border-primary/40 transition-colors duration-500 bg-card/30 backdrop-blur-sm">
        <img src={step.image} alt={step.title} className="w-[200px] h-[140px] object-cover transition-transform duration-700 group-hover:scale-105 opacity-80 group-hover:opacity-100" />
        <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent opacity-40 mix-blend-multiply pointer-events-none" />
      </div>
      <div className="flex flex-col gap-2">
        <div className="text-secondary font-default text-xs font-semibold tracking-wider uppercase flex items-center gap-2">
          {align === 'right' && <span className="w-8 h-px bg-secondary/30 hidden md:block" />}
          مرحله {step.number}
          {align === 'left' && <span className="w-8 h-px bg-secondary/30 hidden md:block" />}
        </div>
        <h3 className="font-default text-2xl md:text-3xl font-bold text-foreground tracking-tight">{step.title}</h3>
        <p className="font-default text-muted-foreground text-sm md:text-base leading-relaxed max-w-[320px]">{step.description}</p>
      </div>
    </div>;
}
function StepItem({
  step,
  index
}: {
  step: typeof steps[0];
  index: number;
}) {
  const stepNumber = index + 1;
  const isEven = stepNumber % 2 === 0;
  const isOdd = !isEven;
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.6
  });
  return <div data-index={index} className="relative flex flex-col md:flex-row items-center justify-center w-full md:py-16 group">
      
      {}
      <div className="md:hidden absolute left-[23px] top-10 -translate-x-1/2 w-5 h-5 rounded-lg bg-background border border-secondary/40 z-10 flex items-center justify-center shadow-sm">
        <div className="w-2 h-2 rounded-lg bg-secondary shadow-md" />
      </div>

      {}
      <div className={`w-full md:w-1/2 flex ${isEven ? 'md:justify-end md:pr-20' : 'md:justify-end md:opacity-0 md:pointer-events-none hidden md:flex'}`}>
        {isEven && <StepCard step={step} align="right" />}
      </div>

      {}
      <div ref={ref} className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 items-center justify-center z-10">
        <div className="w-8 h-8 rounded-lg border border-secondary/20 bg-background flex items-center justify-center backdrop-blur-sm shadow-sm">
          <div className={`w-2.5 h-2.5 rounded-lg bg-secondary transition-all duration-1000 ease-out ${isVisible ? "scale-100 opacity-100 shadow-lg" : "scale-0 opacity-0"}`} />
        </div>
      </div>

      {}
      <div className={`w-full md:w-1/2 flex ${isOdd ? 'md:justify-start md:pl-20' : 'md:justify-start md:opacity-0 md:pointer-events-none hidden md:flex'}`}>
        {isOdd && <StepCard step={step} align="left" />}
      </div>

      {}
      <div className="md:hidden pl-14 w-full py-6">
        <StepCard step={step} align="left" />
      </div>
    </div>;
}
export default function TheDirectorsPath() {
  return <section data-section-id="223307" id="مسیر-بهبودی" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-1/4 left-0 w-[500px] h-[500px] bg-primary/10 rounded-lg blur-[120px] pointer-events-none -translate-x-1/2" />
      <div className="absolute bottom-1/4 right-0 w-[400px] h-[400px] bg-secondary/10 rounded-lg blur-[100px] pointer-events-none translate-x-1/2" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        
        <div className="text-center max-w-3xl mx-auto mb-20 md:mb-32">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 tracking-tight">
            مسیر بهبودی شما
          </h2>
          <p className="font-default text-muted-foreground text-lg md:text-xl leading-relaxed">
            یک سفر چهار مرحله‌ای دقیق و علمی برای تبدیل چالش‌های ذهنی به آرامش و تعادل پایدار.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          {}
          <div className="absolute left-1/2 top-4 bottom-4 w-px bg-gradient-to-b from-transparent via-secondary/40 to-transparent -translate-x-1/2 hidden md:block border-l border-dashed border-secondary/30" />
          
          {}
          <div className="absolute left-[23px] top-4 bottom-4 w-px bg-gradient-to-b from-transparent via-secondary/40 to-transparent md:hidden border-l border-dashed border-secondary/30" />

          <div className="flex flex-col gap-8 md:gap-0">
            {steps.map((step, i) => <StepItem key={i} step={step} index={i} />)}
          </div>
        </div>

      </div>
    </section>;
}